<template>
  <div class="product-list-container">
    <product-list-form v-if="editingProductList" :productList="editingProductList" ></product-list-form>
    <div class="product-list-list" v-else>
      <md-table-card>

        <md-layout class="list-header">

          <md-layout>
            <md-button @click.native="clickCreate()" class="md-icon-button md-raised md-warn">
              <md-icon>add</md-icon>
            </md-button>
          </md-layout>

          <md-layout>
            <translate tag="h1" class="md-title">Product Price Lists</translate>
          </md-layout>

          <md-layout md-align="end">
            <md-layout md-align="end">
            <md-input-container class="search-container">
              <md-icon>search</md-icon>
              <md-input type="tel" @input="searchInput"></md-input>
            </md-input-container>
            </md-layout>
            <md-button @click.native="fetchProductLists()" class="md-icon-button">
              <md-icon>refresh</md-icon>
              <md-tooltip md-direction="bottom">Refresh</md-tooltip>
            </md-button>
          </md-layout>

        </md-layout>

        <md-table md-sort="name" @sort="onSort">
          <md-table-header>
            <md-table-row>
              <md-table-head md-sort-by="id"><translate>ID</translate></md-table-head>
              <md-table-head md-sort-by="name"><translate>Name</translate></md-table-head>
              <md-table-head md-sort-by="products" md-tooltip="Number of products"><translate>Products</translate></md-table-head>
              <md-table-head><translate>Edit</translate></md-table-head>
              <md-table-head><translate>Delete</translate></md-table-head>
            </md-table-row>
          </md-table-header>

          <md-table-body v-if="productListsComputed.length > 0">
            <product-list-row v-for="productList in productListsComputed" :key="productList._id" :productList="productList">
            </product-list-row>
          </md-table-body>
          <md-table-body v-else>
            <md-table-cell><translate>Sorry, no product lists yet</translate></md-table-cell>
          </md-table-body>
        </md-table>

      </md-table-card>

      <md-layout md-align="end" class="active-filter" v-if="productListsComputed.length !== allProductLists.length">
        <span><md-icon>info</md-icon>Filter activated (showing {{productListsComputed.length}} out of {{allProductLists.length}} items)</span>
      </md-layout>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ProductListRow from './Row'
import ProductListForm from './Form'
import orderBy from 'lodash.orderby'
import debounce from 'lodash.debounce'

export default {
  name: 'product-list-list',
  data () {
    return {
      orderField: 'name',
      direction: 'asc',
      search: ''
    }
  },
  async created () {
    await this.fetchProductLists()

    if (this.editId) {
      this.productListEdit(this.editId)
    }
    if (this.create) {
      this.productListCreate()
    }
  },
  // props from Admin Dashboard indicating whether we need to open Form to edit item or create a new one
  props: ['create', 'editId'],
  watch: {
    editId (val) {
      if (val) {
        this.productListEdit(val)
      } else {
        this.productListCancelEdit()
      }
    },
    create (val) {
      if (val) {
        this.productListCreate()
      } else {
        this.productListCancelEdit()
      }
    }
  },
  computed: {
    // get all productLists and sort them by the current sort settings
    productListsComputed () {
      return orderBy(this.allProductLists, this.orderField, this.direction).filter(elem => {
        return elem.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
               elem.customId.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
      })
    },
    ...mapGetters([
      'allProductLists',
      'editingProductList'
    ])
  },
  methods: {
    ...mapMutations([
      'productListEdit',
      'productListCreate',
      'productListCancelEdit'
    ]),
    ...mapActions([
      'fetchProductLists'
    ]),
    onSort (object) {
      this.orderField = object.name
      this.direction = object.type
    },
    clickCreate () {
      this.$router.push({ name: 'tab-3-create' })
      this.productListCreate()
    },
    searchInput: debounce(async function (search) {
      this.search = search
    }, 200)
  },
  components: {
    ProductListForm,
    ProductListRow
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/product-lists/List.vue